/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import moment from 'moment-timezone';

interface SendDurationArgs {
  duration: moment.Duration;
  durationHumanReadable: string;
  sendTime: moment.Moment;
}

export default class SendDuration extends Component<SendDurationArgs> {
  get sendFinishedAt() {
    return moment(this.args.sendTime).add(this.args.duration).format('MMM DD, YYYY [at] h:mm a (UTC Z)');
  }
}
